"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TablesV3Controller", {
    enumerable: true,
    get: function() {
        return TablesV3Controller;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _PagedResponse = require("~/helpers/PagedResponse");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _tablesv3service = require("~/services/v3/tables-v3.service");
const _controllers = require("~/constants/controllers");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let TablesV3Controller = class TablesV3Controller {
    async tableList(context, baseId, sourceId, includeM2M, req) {
        var _req_user;
        return new _PagedResponse.PagedResponseImpl(await this.tablesV3Service.getAccessibleTables(context, {
            baseId,
            sourceId,
            includeM2M: includeM2M === 'true',
            roles: (0, _nocodbsdk.extractRolesObj)(req.user.base_roles),
            user: req.user,
            isPublicBase: ((_req_user = req.user) == null ? void 0 : _req_user.isPublicBase) === true
        }));
    }
    async tableCreate(context, baseId, sourceId, body, req) {
        const result = await this.tablesV3Service.tableCreate(context, {
            baseId: baseId,
            sourceId: sourceId,
            table: body,
            user: req.user
        });
        return result;
    }
    async tableGet(context, tableId, req) {
        const table = await this.tablesV3Service.getTableWithAccessibleViews(context, {
            tableId,
            user: req.user
        });
        return table;
    }
    async tableUpdate(context, tableId, body, req) {
        return await this.tablesV3Service.tableUpdate(context, {
            tableId: tableId,
            table: body,
            baseId: req.ncBaseId,
            user: req.user,
            req
        });
    }
    async tableDelete(context, tableId, req) {
        const result = await this.tablesV3Service.tableDelete(context, {
            tableId,
            user: req.user,
            req
        });
        return result;
    }
    constructor(tablesV3Service){
        this.tablesV3Service = tablesV3Service;
    }
};
_ts_decorate([
    (0, _common.Get)(`${_controllers.PREFIX_APIV3_METABASE}/tables`),
    (0, _extractidsmiddleware.Acl)('tableList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('sourceId')),
    _ts_param(3, (0, _common.Query)('includeM2M')),
    _ts_param(4, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesV3Controller.prototype, "tableList", null);
_ts_decorate([
    (0, _common.Post)(`${_controllers.PREFIX_APIV3_METABASE}/tables`),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('tableCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('sourceId')),
    _ts_param(3, (0, _common.Body)()),
    _ts_param(4, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _nocodbsdk.TableCreateV3Type === "undefined" ? Object : _nocodbsdk.TableCreateV3Type,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesV3Controller.prototype, "tableCreate", null);
_ts_decorate([
    (0, _common.Get)(`${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId`),
    (0, _extractidsmiddleware.Acl)('tableGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesV3Controller.prototype, "tableGet", null);
_ts_decorate([
    (0, _common.Patch)(`${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId`),
    (0, _extractidsmiddleware.Acl)('tableUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.TableUpdateV3Type === "undefined" ? Object : _nocodbsdk.TableUpdateV3Type,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesV3Controller.prototype, "tableUpdate", null);
_ts_decorate([
    (0, _common.Delete)(`${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId`),
    (0, _extractidsmiddleware.Acl)('tableDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesV3Controller.prototype, "tableDelete", null);
TablesV3Controller = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _tablesv3service.TablesV3Service === "undefined" ? Object : _tablesv3service.TablesV3Service
    ])
], TablesV3Controller);
